import swiper from "swiper";
import isMobile from '../../plugins/is-mobile.js';
var store = require("store");
import { TweenMax } from "gsap/TweenMax";
let window_h = $(window).height();

// console.log(window_h);

$('.l-loading').css('height', window_h);

//　トップページでアニメーション再生するか判断
var isTopPage = -1 < $.inArray(location.pathname, ["/", "/index.php"]);
var pathname = function () {
  return location.pathname == "/index.php" ? "/" : location.pathname;
};

console.log(isTopPage);

if (isTopPage) {
  // ==================================================
  // 外部からこのサイトを訪問したユーザーには必ずアニメーションを見せる
  // いちどアニメーションを見せたらサイト内部を回遊している間はアニメーションを見せない
  // ※トップページでリロードした場合は、アニメーションを見せる
  // ==================================================
  var fromOutside = !document.referrer.match(location.host);
  console.log(fromOutside);

  if (fromOutside) {
    store.set("referrer", location.pathname);
  }

  if (window.performance) {
    if (pathname() == store.get("referrer")) {
      $("body").data("animate", true);
      // console.log('aaaaa');
    }
  }
}
store.set("referrer", pathname());

if ($("body").data("animate")) {
  //実行内容


  var videoElem = document.getElementById('top-animation');

  // window.addEventListener("load", (evt) => {
  $(window).on('load', function () {

    $('.l-loading').addClass('is-animation');
    $("body").css("overflow", "hidden");
    $('.l-loading').fadeIn(0);


    $('.l-loading-video').addClass('is-active');

    if (!(isMobile(768))) {
      $('.top-animation').get(0).play();
      $('.top-animation-sp').get(0).play();
    } else {
      setTimeout(function () {
        $('.top-animation').get(0).play();
        $('.top-animation-sp').get(0).play();
        $('.l-loading-video').addClass('is-sp-video');
      }, 500);
    }

  });


  videoElem.addEventListener('ended', function () {
    $(".body-inner").css("display", "block");
    $('.l-loading').fadeOut(1000);
    $("body").css("overflow", "visible");

    var hero = new swiper('.top-hero__bg', {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      effect: "fade",
      speed: 1200,
      slideToClickedSlide: false,
      allowTouchMove: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
    var slider01 = new swiper(".top-clinic-slider", {
      loop: true,
      loopedSlides: 4,
      slidesPerView: "auto",
      spaceBetween: 10,
      speed: 10000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        // 960: {
        //   slidesPerView: 2
        // },
        768: {
          spaceBetween: 8,
        }
      },
    });
  });

} else {
  $(".body-inner").css("display", "block");

  $(".l-loading").css("display", "none");
  setTimeout(function () {
    $('.top-hero').addClass('is-active');
  }, 50);
};

